<template>
  <div class="form">
    <div v-show="!loading">
      <h1>{{ $lang("大眾行山樂") }}</h1>
      <b-form ref="form1" @submit="onSubmit">
        <div class="form-header"></div>
        <div class="px-5" v-html="content">
        </div>
        <div>
          <b-row>
            <b-col md="6">
              <b-form-group horizontal :label-cols="3" :label="$lang('姓名：')">
                <b-form-input
                  type="text"
                  v-model="form.name"
                  name="name"
                  :class="errors.has('name') && 'is-invalid'"
                  v-validate="'required'"
                  :placeholder="$lang('請輸入名字')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('name')">
                  {{ errors.first("name") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group horizontal :label-cols="3" :label="$lang('性別：')">
                <b-select
                  v-model="form.gender"
                  name="sex"
                  :class="errors.has('sex') && 'is-invalid'"
                  v-validate="'required'"
                  :placeholder="$lang('請輸入性別')"
                  :disabled="is_perview"
                >
                  <option value="M">{{ $lang("FIELD_MALE") }}</option>
                  <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
                </b-select>
                <b-form-invalid-feedback :state="errors.has('sex')">
                  {{ errors.first("sex") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('FIELD_ID_NUMBER')"
              >
                <b-form-input
                  type="text"
                  v-model="form.idNumber"
                  name="idNumber"
                  :class="errors.has('idNumber') && 'is-invalid'"
                  v-validate="{ required: true, cycling_idNumber: true }"
                  :placeholder="$lang('請輸入證件號碼')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('idNumber')">
                  {{ errors.first("idNumber") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('電話號碼：')"
              >
                <b-form-input
                  type="text"
                  v-model="form.phone"
                  name="phone"
                  :class="errors.has('phone') && 'is-invalid'"
                  v-validate="'required|mobile'"
                  :placeholder="$lang('請輸入電話')"
                  :disabled="is_perview"
                />
                <b-form-invalid-feedback :state="errors.has('phone')">
                  {{ errors.first("phone") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                horizontal
                :label-cols="3"
                :label="$lang('上車地點:')"
              >
                <b-input-group>
                  <b-form-select
                    v-validate="'required'"
                    :placeholder="$lang('請選擇地點')"
                    :disabled="is_perview"
                    v-model="form.location"
                    name="location"
                    :class="errors.has('location') && 'is-invalid'"
                    :options="options"
                  >
                    <!-- <option :value="1">{{ $lang("澳門綜藝館") }}</option>
                    <option :value="2">
                      {{ $lang("氹仔中央公園(近哥英布拉街位置)") }}
                    </option>
                    <option :value="3">
                      {{
                        $lang(
                          "自行前往活動地點(請於09:20前到達黑沙水庫郊野公園廣場)"
                        )
                      }}
                    </option> -->
                  </b-form-select>
                  <b-form-invalid-feedback :state="errors.has('location')">{{
                    errors.first("location")
                  }}</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!-- <b-col  md="12">
                    <b-form-group :label="$lang('參與日期：')">
                    <b-form-checkbox-group
                        v-model="form.participateDate"
                        :class="errors.has('participateDate') && 'is-invalid'"
                        v-validate="{required: false}"
                        :options="this.participateDate"
                        name="participateDate"
                        :disabled="is_perview || participateDate.isCanSignUp"
                    ></b-form-checkbox-group>
                    <b-form-invalid-feedback :state="errors.has('participateDate')">
                        {{ errors.first("participateDate") }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col> -->
          </b-row>
        </div>

        <template v-for="item in form.teamMembers">
          <mountain-form
            :locationOptions="options"
            :participateDate="participateDate"
            :requiredType="requiredType"
            :key="item.key"
            :value.sync="item"
            :rules="rules"
            class="dashed"
            ref="form-item"
            :disabled="is_perview"
          >
            <template v-if="form.teamMembers.length > 0" v-slot:remove>
              <b-form-group horizontal>
                <label slot="label"></label>
                <b-btn
                  variant="info"
                  size="sm"
                  class="del"
                  @click.prevent="handleRemove(item)"
                  ><i class="fa fa-trash-o" style="margin-right: 5px"></i
                  >{{ $lang("刪除") }}</b-btn
                >
              </b-form-group>
            </template>
          </mountain-form>
        </template>

        <div class="form-footer">
          <div>
            <template v-if="!is_perview">
              <b-btn
                v-if="form.teamMembers.length < 20"
                variant="success btn-round"
                @click.prevent="handleAdd"
                >+{{ $lang("添加參加者") }}</b-btn
              >
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="save"
                :disabled="isDisable"
              >
                {{ $lang("TEXT_SAVE") }}
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="submitForm"
                :disabled="isDisable"
              >
                {{ $lang("提交") }}
              </button>
            </template>
            <p>
              {{ $lang("TITLE_FORM_TIP") }}
            </p>
          </div>
        </div>
      </b-form>
    </div>
    <div class="spinner" v-show="loading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import MountainForm from "@/components/MountainForm";
import InputFile from "@/components/InputFile";
import { ValidationObserver } from "vee-validate";
import utils from "@/helper/utils";

export default {
  props: {
    mode: {
      type: String,
      default: "new",
    },
  },
  components: {
    InputFile,
    MountainForm,
    ValidationObserver,
  },
  data() {
    return {
      options: [{ value: null, text: this.$t("請選擇上車地點") }],
      loading: false,
      index: 4,
      content:'',
      requiredType: false,
      status: "",
      isDisable: false,
      isIdentity: true,
      participateDate: [],
      rules: {},
      form: {
        id: null,
        name: "",
        location: "",
        gender: "M",
        phone: "",
        idNumber: "",
        participateDate: [],
        teamMembers: [
          // {
          //   name: "",
          //   gender: "M",
          //   idNumber: "",
          //   participateDate: [],
          // },
        ],
      },
    };
  },
  methods: {
    save() {
      this.requiredType = false;
      this.status = "draft";
    },
    submitForm() {
      this.requiredType = true;
      this.status = "approval";
    },
    async onSubmit(evt) {
      evt.preventDefault();
      var form = {
        ...this.form,
        status: this.status,
        teamMembers: this.uploadMembers(this.form.teamMembers),
      };
      if (this.status === "draft") {
        this.recordUpdate(form);
        this.errorScoll();
      } else {
        var promise_list = await this.$refs["form-item"].map((item) =>
          item.onSubmit()
        );
        this.$validator.validate().then((validate) => {
          Promise.all(promise_list).then((list) => {
            var result = list.every((item) => item);
            this.errorScoll();
            if (result && validate) {
              this.recordUpdate(form);
              this.errorScoll();
            }
          });
        });
      }
    },
    // 防止連續點擊重複提交
    PreventDuplicateSubmit() {
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    handleRemove(item) {
      if (this.form.teamMembers.length <= 0) {
        return;
      }
      var index = this.form.teamMembers.indexOf(item);
      if (index !== -1) {
        this.form.teamMembers.splice(index, 1);
      }
    },
    handleAdd() {
      this.index++;
      this.form.teamMembers.push({
        index: this.index,
        name: null,
        gender: null,
        idNumber: "",
         phone: "",
        location: null,
        participateDate: this.participateDate,
      });
    },
    uploadMembers(list) {
      return list.map((item, index) => {
        delete item["key"];
        delete item["index"];
        return item;
      });
    },
    recordUpdate(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "mountain-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              }
              var errs = err.data.teamMembers;
              var that = this;
              Object.keys(errs).forEach(function (key) {
                that.notification.error(that.$lang(errs[key].message));
              });
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "mountain-challenge",
            });
          })
          .catch((err) => {
            if (err.data.primaryMember) {
              var primaryMember = err.data.primaryMember;
              this.validateErrors(
                primaryMember.path,
                this.$lang(primaryMember.message)
              );
              this.notification.error(this.$lang(primaryMember.message));
            }
            if (err.data.teamMembers) {
              if (err.data.teamMembers instanceof Array) {
                err.data.teamMembers.forEach((item, index) => {
                  this.$refs["form-item"][index].validateErrors(
                    item.path,
                    this.$lang(item.message)
                  );
                  this.notification.error(this.$lang(item.message));
                });
              } else {
                if (err.data.length == 0) {
                  this.notification.error(this.$lang(err.message));
                }
                var teamMembers = err.data.teamMembers;
                var that = this;
                Object.keys(teamMembers).forEach(function (key) {
                  that.$refs["form-item"][key].validateErrors(
                    teamMembers[key].path,
                    that.$lang(teamMembers[key].message)
                  );
                  that.notification.error(that.$lang(teamMembers[key].message));
                });
              }
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      }
    },
    async recordPro(form) {
      this.PreventDuplicateSubmit();
      return new Promise((resolve, reject) => {
        $apis.mountain
          .recordUpdate(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // save
    async saveForm(form) {
      this.PreventDuplicateSubmit();
      return new Promise((resolve, reject) => {
        $apis.mountain
          .save(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    async recordDetail(id) {
      if (this.mode === "perview") {
        this.loading = true;
        let resp = await $apis.mountain.recordDetail({
          id,
        });
        this.loading = false;
        this.form = resp.data;
      } else {
        this.loading = true;
        let resp = await $apis.mountain.load({ id });
        this.loading = false;
        this.form = resp.data;
      }
      this.form.participateDate = this.participateDate;
      if (this.form.teamMembers.length > 0) {
        this.form.teamMembers.forEach((element) => {
          element.participateDate = this.participateDate;
        });
      }
      console.log(this.form);
    },
    getUserInfo() {
      this.loading = true;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          var data = resp.data;
          (this.form.name =
            data.firstNameZh + data.lastNameZh ||
            data.FirstnamePt + data.LastnamePt),
            (this.form.gender = data.gender);
          this.form.idNumber = data.idNumber.slice(-4);
          this.form.phone = data.contact[1] || "";
          this.form.location = data.location;
          console.log(data.location, 1);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 獲取參數日期
    recordList() {
      $apis.mountain
        .recordList()
        .then((resp) => {
          // this.participateDate = resp.data.participateDate;
          this.participateDate = [resp.data.participateDate.days[0].value];
          this.form.participateDate = [resp.data.participateDate.days[0].value];
          this.content=resp.data.activityContent
          var that = this;
          Object.keys(resp.data.locations).forEach(function (key) {
            that.options.push({
              value: key,
              text: resp.data.locations[key],
            });
          });
          // for(var i = 0; i < resp.data.participateDate.length; i++) {
          //     this.participateDate.push({ html: resp.data.participateDate[i].html, value: resp.data.participateDate[i].value, disabled: !resp.data.participateDate[i].isCanSignUp });
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    disabled() {
      return this.mode === "perview" || this.mode === "edit";
    },
    is_perview() {
      return this.mode === "perview";
    },
    is_edit() {
      return this.mode === "edit";
    },
    is_new() {
      return this.mode === "new";
    },
    downPdf() {
      return this.$store.getters["base/mountainClimbingHealthFileExample"];
    },
    link() {
      return this.$store.getters["base/baseUrl"];
    },
    url() {
      return this.link + this.downPdf;
    },
  },
  created() {
    var id = this.$route.params.slug;
    var isNew = this.is_new;
    this.form.id = id;
    id && this.recordDetail(id);
    isNew && this.getUserInfo();
    this.recordList();
  },
};
</script>
